export const SET_LOADER = 'SET_LOADER '
export const SET_SELECTED_VALUE = 'SET_SELECTED_VALUE'

